import { Injectable, EventEmitter } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})

export class LoginService {
    private REST_API_SERVER = environment.apiUrl;
    headers = new HttpHeaders().set('Content-Type', 'application/json');
    options = { headers: this.headers };

    public userLoggedIn: EventEmitter<any> = new EventEmitter();  // event triggered when user will be logged in
    public userLoggedOut: EventEmitter<any> = new EventEmitter();  // event triggered when user will be logged out

    constructor(
        private httpClient: HttpClient
    ) { }

    public authenticate(loginData: any) {
        loginData = {...loginData, "grant_type": "password",
        "client_id": environment.passport.client_id,
        "client_secret" : environment.passport.client_secret};

        return this.httpClient.post(
            environment.authUrl + '/oauth/token',
            loginData,
            this.options
        );
    }

    public getPostLoginData(){
       let options_data=  { headers : new HttpHeaders({
            Authorization: localStorage.getItem('bearerToken')
        })};
        let impersonate = localStorage.getItem('impersonate');

        if (impersonate) {
            options_data.headers = options_data.headers.set('x-impersonate', impersonate);
        }
        return this.httpClient.get<any>(
            this.REST_API_SERVER + "/getPostLoginData",
            options_data
        )
    }

    public forgotPassword(forgotPasswordData: any) {
        forgotPasswordData = { ...forgotPasswordData };

        return this.httpClient.post(
            this.REST_API_SERVER + '/forgotPassword',
            forgotPasswordData,
            this.options
        );
    }

    public validatePasswordToken(passwordToken: any) {
        let passwordTokenData = { passwordToken: passwordToken };

        return this.httpClient.post(
            this.REST_API_SERVER + '/validatePasswordToken',
            passwordTokenData,
            this.options
        );
    }

    public updatePassword(passwordToken:any, updatePasswordData: any) {
        updatePasswordData = { passwordToken: passwordToken, ...updatePasswordData };

        return this.httpClient.post(
            this.REST_API_SERVER + '/updatePassword',
            updatePasswordData,
            this.options
        );
    }

    // Returns true when user is looged in and email is verified
    public isLoggedIn(): boolean {
        const user = localStorage.getItem('bearerToken');        
        return (user !== null) ? true : false;
    }
    public loggedType(): boolean {
        const type = localStorage.getItem('type');
        return (type !== null && type == 'c') ? true : false;
    }
    public landingPage(): boolean {
        const page = localStorage.getItem('defaultLandingPage');
        return (page !== null && page == 'dashboard') ? true : false;
    }

    /**
     * Closes the backend login report (session duration tracking) for loginReportId.
     * Called by SessionTimeoutService before Auth0 sign-out so auto-timeout and
     * manual logout both stop the tracked session.
     */
    public logout(logoutData: any, token: any) {
        let logoutHeaders = new HttpHeaders({
            Authorization: token
        });
        let logoutOptions = { headers: logoutHeaders };
        let loginDetail = { loginId: logoutData.loginId, loginReportId : logoutData.loginReportId};
        return this.httpClient.post<any>(
            this.REST_API_SERVER + '/logout',
            loginDetail,
            logoutOptions
        ).pipe(map(user => {
            localStorage.clear();
            window.localStorage.setItem('loggedIn', 'false');
            this.userLoggedOut.emit();

            return user;
        }), catchError(
            error => {
                return throwError(error);
            }
        ));
    }

    public loggedUserData(data: any = {}) {
        let headers = new HttpHeaders().set('Authorization', localStorage.getItem('bearerToken'));
        let impersonate = localStorage.getItem('impersonate');
    
        if (impersonate) {
            headers = headers.set('x-impersonate', impersonate);
        }
    
        // Convert `data` to query parameters
        const queryParams = new URLSearchParams();
        Object.keys(data).forEach(key => {
            queryParams.set(key, data[key]);
        });
    
        // Add query params to the URL
        const urlWithParams = `${this.REST_API_SERVER}/loggedUserData?${queryParams.toString()}`;
    
        let options = { headers: headers };
    
        return this.httpClient.get<any>(urlWithParams, options).pipe(
            map(user => {
                return user;
            }),
            catchError(error => {
                localStorage.clear();
                window.location.href = '/login';
                return throwError(error);
            })
        );
    }

    public getImpersonateEmployeeList(){
       let options_data=  { headers : new HttpHeaders({
            Authorization: localStorage.getItem('bearerToken')
        })};
        let impersonate = localStorage.getItem('impersonate');

        if (impersonate) {
            options_data.headers = options_data.headers.set('x-impersonate', impersonate);
        }
        return this.httpClient.get<any>(
            this.REST_API_SERVER + "/employee-list-for-impersonate",
            options_data
        )
    }
    
}